import { useState, ChangeEvent } from 'react';

import { Box, Tabs, Tab, Grid, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import RecentActivity from './RecentActivity';
import ParametersGasStationTab from './ParametersGasStationTab';
import ParametersCryoptoPaymentTab from './ParametersCryoptoPaymentTab';
import InfoProjectTab, { projectTypeLabel } from './InfoProjectTab';
import { ShowBase, TextField, ReferenceField, useRecordContext } from "react-admin";
import ComponentShow, { ShowActions } from '../../../components/PageComponents/ComponentShow';
import DetailHeader from '../../../components/PageComponents/DetailHeader';
import { StatusLabel } from '../../../components/Label/status';
import { formatDateTime } from '../../../utils/paymentFormat';
const TabsWrapper = styled(Tabs)(
  () => `
`
);
const Content = () => {
  const { t }: { t: any } = useTranslation();
  const record = useRecordContext();
  if (!record) return null;
  return (
    <ComponentShow
      header={
        <DetailHeader
          kind="Entity"
          title={record.name}
          status={<StatusLabel statusField="status" />}
          facts={[
            record.typeProject && t(projectTypeLabel(record.typeProject)),
            record.accountId && (
              <ReferenceField source="accountId" reference="accounts" link={false}>
                <TextField source="name" variant="body2" color="text.secondary" />
              </ReferenceField>
            ),
            formatDateTime(record.dateCreated),
          ]}
        />
      }
    >
      <ContentShow />
    </ComponentShow>
  );
}
const ProjectShow = () => {
  return (
    <ShowBase>
      <Content/>
    </ShowBase>
  )
}

const ParametersTab = () => {
  const record = useRecordContext();
  if (!record) return null;
  const tabByProjectType = {
    "gasStation": <ParametersGasStationTab />,
    "cryptoPayment": <ParametersCryoptoPaymentTab />,
  };

  return tabByProjectType[record.typeProject] || null;
}

const ContentShow = () => {

  const [currentTab, setCurrentTab] = useState<string>('infoProject');
  const { t }: { t: any } = useTranslation();

  const tabs = [
    { value: 'infoProject', label: t('Information') },
    { value: 'parameters', label: t('Parameters') },
  ];

  const handleTabsChange = (_event: ChangeEvent<{}>, value: string): void => {
    setCurrentTab(value);
  };

  return (
    <>
      <Box
        sx={{
          mt: 3,
          marginBottom:4
        }}
      >
        <Grid
          sx={{
            px: 4,
          }}
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={4}
        >

          <Grid item xs={9} md={9}>
            <TabsWrapper
              onChange={handleTabsChange}
              value={currentTab}
              variant="scrollable"
              scrollButtons="auto"
              textColor="primary"
              indicatorColor="primary"
            >
              {tabs.map((tab) => (
                <Tab key={tab.value} label={tab.label} value={tab.value} />
              ))}
            </TabsWrapper>
          </Grid>
          <Grid item xs={3} md={3} sx={{display: 'flex', justifyContent: 'flex-end'}}>
            <ShowActions resource="projects" />
          </Grid>
          <Grid item xs={12} md={8}>
            {currentTab === 'infoProject' && <InfoProjectTab />}
            {currentTab === 'parameters' && <ParametersTab />}
          </Grid>
          <Grid item xs={12} md={4}>
            <RecentActivity />
          </Grid>
        </Grid>
      </Box>
      </>
  );
}

export default ProjectShow
